import React, { useEffect, useState } from "react";
import "./CreateHelpTicketStyle.css";
import Dropdown from "../../../components/globalComponents/dropdown/Dropdown";
import TextField from "../../../components/globalComponents/textFields/TextField";
import TextArea from "../../../components/globalComponents/textArea/TextArea";
import PrimaryButton from "../../../components/globalComponents/buttons/primaryButton/PrimaryButton";
// import CustomUploadBox from "../../../components/globalComponents/customUploadBox/CustomUploadBox";
import ErrorToast from "../../../components/Toast/ErrorToast";
import {
  helpDeskSliceData,
  getCategories,
  getSpecificCategories,
  postTicketData,
  clearState,
} from "../../../reducers/helpDeskSlice";
import { useDispatch, useSelector } from "react-redux";
import ConfirmationPopup from "../../../components/popups/confirmationPopup/ConfirmationPopup";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../components/globalComponents/PageLoader/PageLoader";

// import { helpDeskSliceData, getCategories } from "../../reducers/helpDeskSlice";

const CreateHelpTicket = () => {
  const navigate = useNavigate();

  const [category, setCategory] = useState("");
  const [subCat, setSubCat] = useState("");
  const [about, setAbout] = useState("");
  const [message, setMessage] = useState("");
  const [show, setShow] = useState(false);
  const [reset, setReset] = useState(false);

  console.log(message);

  const [isShowError, setIsShowError] = useState(false);
  let errMessage = "Please fill the required fields";

  const dispatch = useDispatch();
  const { isFetching, categoriesData, subCategoriesData, submittedTicket } =
    useSelector(helpDeskSliceData);

  useEffect(() => {
    setReset(true);
  }, [subCategoriesData]);

  // useEffect(() => {
  //     console.log('isSuccess', isSuccess);
  //     if (isSuccess) {
  //         setCategory("")
  //         setSubCat("")
  //         setAbout("")
  //         setMessage("")
  //         setReset(true)

  //     }
  // }, [isSuccess])
  const handleConfirmationPopup = () => {
    setCategory("");
    setSubCat("");
    setAbout("");
    setMessage("");
    setReset(true);
    setShow(false);
    dispatch(clearState());
  };


  useEffect(() => {
    dispatch(getCategories());
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (category !== "") {
      dispatch(getSpecificCategories(category));
    }
    // eslint-disable-next-line
  }, [category]);

  useEffect(() => {
    if (submittedTicket) {
      setShow(true);
      dispatch(clearState());
    }
    // eslint-disable-next-line
  }, [submittedTicket]);

  const handleSubmit = () => {
    if (category !== "" && subCat !== "" && about !== "" && message !== "") {
      console.log("success");
      const obj = {
        category_id: category,
        sub_category_id: subCat,
        subject: about,
        description: message,
      };
      dispatch(postTicketData(obj));
    } else {
      setIsShowError(true);
    }
  };
  const navigateTo = () => {
    navigate("/help");
    handleConfirmationPopup();
  };
  return (
    <>
      {isFetching && <PageLoader />}
      <ErrorToast
        show={isShowError}
        setShow={() => setIsShowError(false)}
        message={errMessage}
      />
      <ConfirmationPopup
        title={"New Ticket Raised"}
        boldText={"You have successfully raised a new ticket."}
        text={
          " For view relevant ticket information, visit your Ticket Record."
        }
        btnText={"Continue"}
        btnType={"successBtn"}
        btnHandler={navigateTo}
        show={show}
        handleClose={() => setShow(false)}
      />
      <div className="pageHeader">
        <p className="componentHeading"></p>
        <div className="pageTogglers">
          <div className="pageToggler active">
            <svg
              width="21"
              height="20"
              viewBox="0 0 21 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.97325 1.875H14.0268C14.7041 1.87499 15.2505 1.87499 15.6929 1.91114C16.1484 1.94835 16.5485 2.02699 16.9187 2.2156C17.5067 2.51521 17.9848 2.99327 18.2844 3.58128C18.473 3.95146 18.5516 4.35158 18.5889 4.80711C18.625 5.24953 18.625 5.79587 18.625 6.47323V11.2722C18.625 11.8358 18.625 12.2904 18.5998 12.6604C18.5738 13.0409 18.5191 13.3773 18.3871 13.6959C18.07 14.4616 17.4616 15.07 16.6959 15.3871C16.3773 15.5191 16.0409 15.5738 15.6604 15.5998C15.2904 15.625 14.8358 15.625 14.2722 15.625H14.25C13.8129 15.625 13.6954 15.6289 13.594 15.6529C13.4366 15.69 13.29 15.7633 13.1659 15.8669C13.0859 15.9337 13.0123 16.0253 12.75 16.375L11.5212 18.0134C11.4414 18.1198 11.3588 18.2301 11.2806 18.317C11.1958 18.4112 11.0669 18.5361 10.8776 18.6097C10.6347 18.7042 10.3653 18.7042 10.1224 18.6097C9.93311 18.5361 9.80417 18.4112 9.71939 18.317C9.64124 18.2301 9.55858 18.1198 9.47882 18.0134L8.25 16.375C7.98772 16.0253 7.9141 15.9337 7.83411 15.8669C7.70996 15.7633 7.56338 15.69 7.40599 15.6529C7.3046 15.6289 7.18714 15.625 6.75 15.625H6.7278C6.1642 15.625 5.70957 15.625 5.33957 15.5998C4.9591 15.5738 4.62268 15.5191 4.30411 15.3871C3.5384 15.07 2.93005 14.4616 2.61288 13.6959C2.48092 13.3773 2.4262 13.0409 2.40024 12.6604C2.37499 12.2904 2.375 11.8358 2.375 11.2722L2.375 6.47325C2.37499 5.79588 2.37499 5.24953 2.41114 4.80711C2.44835 4.35158 2.52699 3.95146 2.7156 3.58128C3.01521 2.99327 3.49327 2.51521 4.08128 2.2156C4.45146 2.02699 4.85158 1.94835 5.30711 1.91114C5.74953 1.87499 6.29588 1.87499 6.97325 1.875ZM5.4089 3.15699C5.03067 3.18789 4.81337 3.2455 4.64877 3.32936C4.29596 3.50913 4.00913 3.79596 3.82936 4.14877C3.7455 4.31337 3.68789 4.53067 3.65699 4.9089C3.62549 5.29443 3.625 5.78962 3.625 6.5V11.25C3.625 11.841 3.62534 12.2529 3.64734 12.5753C3.66895 12.8922 3.70938 13.0767 3.76773 13.2175C3.95803 13.677 4.32304 14.042 4.78247 14.2323C4.92333 14.2906 5.10784 14.331 5.42466 14.3527C5.74709 14.3747 6.15902 14.375 6.75 14.375C6.77052 14.375 6.79078 14.375 6.8108 14.375C7.15864 14.3748 7.43188 14.3746 7.69318 14.4363C8.03944 14.518 8.3619 14.6793 8.63505 14.9072C8.84117 15.0793 9.00499 15.298 9.21354 15.5763C9.22554 15.5924 9.23769 15.6086 9.25 15.625L10.4667 17.2472C10.4784 17.2629 10.4895 17.2776 10.5 17.2916C10.5105 17.2776 10.5216 17.2629 10.5333 17.2472L11.75 15.625C11.7623 15.6086 11.7745 15.5924 11.7865 15.5763C11.995 15.298 12.1588 15.0793 12.365 14.9072C12.6381 14.6793 12.9606 14.518 13.3068 14.4363C13.5681 14.3746 13.8414 14.3748 14.1892 14.375C14.2092 14.375 14.2295 14.375 14.25 14.375C14.841 14.375 15.2529 14.3747 15.5753 14.3527C15.8922 14.331 16.0767 14.2906 16.2175 14.2323C16.677 14.042 17.042 13.677 17.2323 13.2175C17.2906 13.0767 17.331 12.8922 17.3527 12.5753C17.3747 12.2529 17.375 11.841 17.375 11.25V6.5C17.375 5.78962 17.3745 5.29443 17.343 4.9089C17.3121 4.53067 17.2545 4.31337 17.1706 4.14877C16.9909 3.79596 16.704 3.50913 16.3512 3.32936C16.1866 3.2455 15.9693 3.18789 15.5911 3.15699C15.2056 3.12549 14.7104 3.125 14 3.125H7C6.28962 3.125 5.79443 3.12549 5.4089 3.15699ZM10.5 5.625C10.8452 5.625 11.125 5.90482 11.125 6.25V8.125H13C13.3452 8.125 13.625 8.40482 13.625 8.75C13.625 9.09518 13.3452 9.375 13 9.375H11.125V11.25C11.125 11.5952 10.8452 11.875 10.5 11.875C10.1548 11.875 9.875 11.5952 9.875 11.25V9.375H8C7.65482 9.375 7.375 9.09518 7.375 8.75C7.375 8.40482 7.65482 8.125 8 8.125H9.875V6.25C9.875 5.90482 10.1548 5.625 10.5 5.625Z"
                fill="#262626"
              />
            </svg>
            Raise New Ticket
          </div>
        </div>
        <div></div>
      </div>
      <div className="raiseTicketContainerOuter">
        <div className="raiseTicketContainer">
          <div className="raiseTicketContainerInner">
            <Dropdown
              label={"Ticket Category"}
              isImportant={true}
              onChange={setCategory}
              options={categoriesData}
            />
            <Dropdown
              setReset={setReset}
              reset={reset}
              label={"Sub Category"}
              isImportant={true}
              onChange={setSubCat}
              options={subCategoriesData}
            />
            <TextField
              labelName={"What is this ticket about?"}
              inputType={"text"}
              placeholder={"Describe your problem in less than 150 characters"}
              isImportant={true}
              onChange={(e) => setAbout(e.target.value)}
              value={about}
            />
            <TextArea
              labelName={
                "Can you share some details about the assistance required from us?"
              }
              placeholder={"Type your message here..."}
              isImportant={true}
              onChange={(e) => setMessage(e.target.value)}
              value={message}
            />
          </div>
          {/* <div className="formGrp">
            <CustomUploadBox />
          </div> */}
          <div className="raiseTicketFooter">
            <PrimaryButton
              classname={"primaryBtn"}
              children={"Submit"}
              onClick={handleSubmit}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateHelpTicket;
